import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})

export class LanguageService {
  private readonly translate = inject(TranslateService);
  private readonly defaultLang = 'en';

  constructor() {
    const savedLang = localStorage.getItem('lang') || this.defaultLang;
    this.setLanguage(savedLang);
  }

  setLanguage(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);

    const isRtl = lang === 'ar';
    const dir = isRtl ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    
    if (isRtl) {
      document.documentElement.classList.add('rtl');
    } else {
      document.documentElement.classList.remove('rtl');
    }
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang() || this.defaultLang;
  }
}
